import React from 'react';

interface SeasonAnalyticsCueProps {
  className?: string;
}

const SeasonAnalyticsCue: React.FC<SeasonAnalyticsCueProps> = ({ className = '' }) => {
  return (
    <span
      className={`inline-flex shrink-0 items-center gap-1.5 rounded-full border border-sd-line bg-[#f6fff0] px-2.5 py-1 text-[11px] font-semibold leading-none text-sd-navy shadow-[0_1px_3px_rgba(5,57,107,0.08)] ${className}`}
      aria-hidden="true"
    >
      <span className="flex h-4 w-4 items-center justify-center rounded-full bg-sd-accent/30">
        <svg className="h-2.5 w-2.5" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <rect x="2" y="9" width="2.5" height="5" rx="0.5" fill="currentColor" />
          <rect x="6.75" y="6" width="2.5" height="8" rx="0.5" fill="currentColor" />
          <rect x="11.5" y="3" width="2.5" height="11" rx="0.5" fill="currentColor" />
        </svg>
      </span>
      <span>Analytics</span>
      <span className="text-sd-green font-bold" aria-hidden="true">
        &rarr;
      </span>
    </span>
  );
};

export default SeasonAnalyticsCue;
